/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Tenant enrollment request
 * @export
 * @interface TenantEnrollmentRequest
 */
export interface TenantEnrollmentRequest {
    /**
     * Organization name
     * @type {string}
     * @memberof TenantEnrollmentRequest
     */
    organizationName?: string;
    /**
     * Organization domain
     * @type {string}
     * @memberof TenantEnrollmentRequest
     */
    domain?: string;
    /**
     * Admin user email
     * @type {string}
     * @memberof TenantEnrollmentRequest
     */
    adminEmail?: string;
    /**
     * Admin user first name
     * @type {string}
     * @memberof TenantEnrollmentRequest
     */
    adminFirstName?: string;
    /**
     * Admin user last name
     * @type {string}
     * @memberof TenantEnrollmentRequest
     */
    adminLastName?: string;
    /**
     * Admin user password
     * @type {string}
     * @memberof TenantEnrollmentRequest
     */
    adminPassword?: string;
    /**
     * SSO provider type
     * @type {string}
     * @memberof TenantEnrollmentRequest
     */
    ssoProviderType?: TenantEnrollmentRequestSsoProviderTypeEnum;
    /**
     * SSO configuration details
     * @type {{ [key: string]: any; }}
     * @memberof TenantEnrollmentRequest
     */
    providerConfig?: { [key: string]: any; };
    /**
     * Additional organization settings
     * @type {{ [key: string]: any; }}
     * @memberof TenantEnrollmentRequest
     */
    settings?: { [key: string]: any; };
    /**
     * Existing customer ID to bind the new tenant to (optional)
     * @type {string}
     * @memberof TenantEnrollmentRequest
     */
    customerId?: string;
    /**
     * Display name for the new tenant (distinct from organizationName)
     * @type {string}
     * @memberof TenantEnrollmentRequest
     */
    tenantName?: string;
    /**
     * When true (default when relationshipSourceTenantId is set), create an active outbound tenant relationship from the session tenant to the new tenant during enrollment
     * @type {boolean}
     * @memberof TenantEnrollmentRequest
     */
    createOutboundRelationshipFromSessionTenant?: boolean;
    /**
     * Source tenant ID for the outbound relationship (typically the caller's current tenant)
     * @type {string}
     * @memberof TenantEnrollmentRequest
     */
    relationshipSourceTenantId?: string;
}


/**
 * @export
 */
export const TenantEnrollmentRequestSsoProviderTypeEnum = {
    Azure: 'azure',
    Okta: 'okta',
    Google: 'google',
    Local: 'local'
} as const;
export type TenantEnrollmentRequestSsoProviderTypeEnum = typeof TenantEnrollmentRequestSsoProviderTypeEnum[keyof typeof TenantEnrollmentRequestSsoProviderTypeEnum];


/**
 * Check if a given object implements the TenantEnrollmentRequest interface.
 */
export function instanceOfTenantEnrollmentRequest(value: object): value is TenantEnrollmentRequest {
    return true;
}

export function TenantEnrollmentRequestFromJSON(json: any): TenantEnrollmentRequest {
    return TenantEnrollmentRequestFromJSONTyped(json, false);
}

export function TenantEnrollmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantEnrollmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'organizationName': json['organizationName'] == null ? undefined : json['organizationName'],
        'domain': json['domain'] == null ? undefined : json['domain'],
        'adminEmail': json['adminEmail'] == null ? undefined : json['adminEmail'],
        'adminFirstName': json['adminFirstName'] == null ? undefined : json['adminFirstName'],
        'adminLastName': json['adminLastName'] == null ? undefined : json['adminLastName'],
        'adminPassword': json['adminPassword'] == null ? undefined : json['adminPassword'],
        'ssoProviderType': json['ssoProviderType'] == null ? undefined : json['ssoProviderType'],
        'providerConfig': json['providerConfig'] == null ? undefined : json['providerConfig'],
        'settings': json['settings'] == null ? undefined : json['settings'],
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
        'tenantName': json['tenantName'] == null ? undefined : json['tenantName'],
        'createOutboundRelationshipFromSessionTenant': json['createOutboundRelationshipFromSessionTenant'] == null ? undefined : json['createOutboundRelationshipFromSessionTenant'],
        'relationshipSourceTenantId': json['relationshipSourceTenantId'] == null ? undefined : json['relationshipSourceTenantId'],
    };
}

export function TenantEnrollmentRequestToJSON(json: any): TenantEnrollmentRequest {
    return TenantEnrollmentRequestToJSONTyped(json, false);
}

export function TenantEnrollmentRequestToJSONTyped(value?: TenantEnrollmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organizationName': value['organizationName'],
        'domain': value['domain'],
        'adminEmail': value['adminEmail'],
        'adminFirstName': value['adminFirstName'],
        'adminLastName': value['adminLastName'],
        'adminPassword': value['adminPassword'],
        'ssoProviderType': value['ssoProviderType'],
        'providerConfig': value['providerConfig'],
        'settings': value['settings'],
        'customerId': value['customerId'],
        'tenantName': value['tenantName'],
        'createOutboundRelationshipFromSessionTenant': value['createOutboundRelationshipFromSessionTenant'],
        'relationshipSourceTenantId': value['relationshipSourceTenantId'],
    };
}

